import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import LightBox from '../../LightBox'
import { getImageAssetPath, IMAGE_ASSET_PATH_FILTER_RESIZE_TO_LIMIT } from '@aytm/lib/common/assets'

const CLASS = 'insights-portal-subject-view-image'

const Image = props => {
  const imageRef = useRef()

  const src = getImageAssetPath({
    width: 480,
    height: 480,
    path: props.path,
    filter: IMAGE_ASSET_PATH_FILTER_RESIZE_TO_LIMIT
  })

  return props.path ? (
    <div ref={imageRef} className={`${CLASS}-container`}>
      <img className={CLASS} src={src} draggable={false} loading={'lazy'} />
      <LightBox onTarget={() => imageRef.current} src={props.url} className={'PRAYTMTheme'} />
      <div className={`${CLASS}-icon-container`}>
        <i className={`icon-aytmfd-zoom ${CLASS}-icon`} />
      </div>
    </div>
  ) : (
    <div ref={imageRef} className={CLASS} draggable={false} />
  )
}

Image.propTypes = {
  className: PropTypes.string,
  url: PropTypes.string,
  path: PropTypes.string,
  condensed: PropTypes.bool,
  onShow: PropTypes.func
}

export default Image
